<div class="modal-body text-center">
    <p>{{message}}</p>
    <input 
        #blockReasonInput
        #reason="ngModel"
        type="text" 
        [ngClass]="{'is-invalid': reason.invalid && (reason.dirty || reason.touched)}"
        class="form-control" 
        placeholder="Write block reason" 
        [(ngModel)]="blockReason" 
        required
    >
    <br>
    <button type="button" class="btn btn-light" (click)="confirm()">Yes</button>
    <button type="button" class="btn btn-primary" (click)="decline()">No</button>
</div>